import { Component, Input, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-booking-timer',
  templateUrl: './booking-timer.component.html',
  styleUrls: ['./booking-timer.component.scss'],
})
//AI generated
export class BookingTimerComponent implements OnInit, OnDestroy {

  @Input() startTime!: Date | string;
  @Input() endTime!: Date | string;

  remainingLabel = '00:00';
  progress = 0;

  private intervalId?: number;
  private totalDurationMs = 0;

  ngOnInit(): void {
    const start = new Date(this.startTime).getTime();
    const end = new Date(this.endTime).getTime();

    this.totalDurationMs = end - start;

    this.updateTimer();
    this.intervalId = window.setInterval(() => {
      this.updateTimer();
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  private updateTimer(): void {
    const now = Date.now();
    const end = new Date(this.endTime).getTime();

    let remainingMs = end - now;

    if (remainingMs <= 0) {
      this.remainingLabel = '00:00';
      this.progress = 100;
      clearInterval(this.intervalId);
      return;
    }

    const totalSeconds = Math.floor(remainingMs / 1000);

    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    this.remainingLabel = this.formatTime(
      days,
      hours,
      minutes,
      seconds
    );

    const elapsed = this.totalDurationMs - remainingMs;
    this.progress = Math.min(
      (elapsed / this.totalDurationMs) * 100,
      100
    );
  }

  private formatTime(
    days: number,
    hours: number,
    minutes: number,
    seconds: number
  ): string {
    const parts: string[] = [];

    if (days > 0) {
      parts.push(days.toString().padStart(2, '0'));
    }

    if (hours > 0 || parts.length) {
      parts.push(hours.toString().padStart(2, '0'));
    }

    parts.push(minutes.toString().padStart(2, '0'));
    parts.push(seconds.toString().padStart(2, '0'));

    return parts.join(':');
  }
}
